import { createAction, props } from '@ngrx/store';

export const setIsuredMattersValues = createAction(
  '[IsuredMattersValues] Set Data',
  props<{ predioValue: number; conteudoValue: number,lucroValue: number,predioConteudo: number, source: string | undefined }>()
);
